import {Component, OnDestroy, OnInit} from '@angular/core';
import {Validators, FormGroup, FormBuilder, FormControl} from '@angular/forms';
import {LoadingService} from '../../services/loading/loading.service';
import {AlertService} from '../../services/alert/alert.service';
import {ActivatedRoute} from '@angular/router';
import {ShipmentDeliveryDataService} from '../../services/shipment-delivery-data/shipment-delivery-data.service';
import {FrtDeliveryExceptionCodesService} from '../../services/frt-delivery-exception-codes/frt-delivery-exception-codes.service';
import {FrtBillOfLadingService} from 'src/app/features/frt-bill-of-lading/frt-bill-of-lading.service';
import {BehaviorSubject, takeWhile} from 'rxjs';
import {UploadService} from '../upload/upload.service';
import AppConstants from 'src/app/shared/common-components/AppConstants';
import moment from 'moment';
import { CommonValidators } from 'src/app/shared/common-components/common-validators';


@Component({
    selector: 'app-shipment-delivery',
    templateUrl: './shipment-delivery.component.html',
    styleUrls: ['./shipment-delivery.component.css'],
    standalone: false
})
export class ShipmentDeliveryComponent implements OnInit, OnDestroy {
  shipmentDeliveryForm: FormGroup;
  messageValue: any;
  private observer$ = new BehaviorSubject(true);
  validationMessages = {
    'pickupDate': [
      {type: 'required', message: 'Actual Pickup Date is required'}
    ],
    'deliveryDate': [
      {type: 'required', message: 'Actual Delivery Date is required'}
    ]
  };
  shipmentBolDtlsId: any;
  shipmentInfoId: any;
  shipmentDeliveryId: number;
  shipmentDeliveryData: any = {};
  frtBillOfLadingDetails: any = {};
  frtBolDetails: any = {};
  shipmentBOLNumber: string;
  shipmentCreateDate: Date;
  requiredDeliveryDate: Date;
  requiredPickupDate: Date;
  minDate: Date;
  deliveryDateTime: any;
  pickupDateTime: any;
  dateCompareMessage = '';
  dateTimeValidation = false;
  organizationId:any;
  exceptionCodes: any = [];
  listHrs: {key: String, value:String}[] = [];
  constructor(private formBuilder: FormBuilder, private uploadService: UploadService,
              private loader: LoadingService,
              private alertService: AlertService, private route: ActivatedRoute,
              private shipmentDeliveryDataService: ShipmentDeliveryDataService,
              private billOfLadingService: FrtBillOfLadingService,
              private frtDeliveryExceptionCodesService: FrtDeliveryExceptionCodesService
  ) {
  }

  ngOnInit() {
    // url parameters
    this.getFrtDeliveryExceptionCodes();
    this.shipmentInfoId = this.route.snapshot.queryParamMap.get('shipmentInfoId');
    this.organizationId = this.route.snapshot.queryParamMap.get('organizationId');
    this.createShipmentDeliveryForm();
    this.getShipmentDeliveryDataByFRTBolDetailsId(this.shipmentInfoId);
    this.minDate = new Date();
    this.generateHours();
    this.initCurrentTime();
  }

  createShipmentDeliveryForm() {
    this.shipmentDeliveryForm = this.formBuilder.group({
      actualPickupDate: new FormControl(''),
      additionalComments: new FormControl(''),
      filePicker: new FormControl(''),
      frtDeliveryExceptionCode: new FormControl(null),
      frtPickupExceptionCode: new FormControl(null),
      pickupTimeSelection: new FormControl('',[Validators.required]),
      pickupDateSelection: new FormControl({value: moment().format('MM/DD/YYYY'), disabled: true},[Validators.required, CommonValidators.usDate]),

      deliveryTimeSelection: new FormControl('',[Validators.required]),
      deliveryDateSelection: new FormControl({value: moment().format('MM/DD/YYYY'), disabled: true},[Validators.required, CommonValidators.usDate])
    });
  }

  /**
   * @description To get shipment delivery data by FRT BOL Details Id.
   * @param frtBolDetailsId: FRT BOL Details Id.
   */
  getShipmentDeliveryDataByFRTBolDetailsId(shipmentInfoId) {
    this.loader.show();
    this.billOfLadingService.getBolDetailsByShipmentId(shipmentInfoId).pipe(takeWhile(() => this.observer$.value)).subscribe(data => {
      if (data !== null) {
        this.frtBillOfLadingDetails = data;
        this.shipmentBolDtlsId = this.frtBillOfLadingDetails.frtBolDetailsID;
        this.shipmentBOLNumber = this.frtBillOfLadingDetails.bolNumber;
        this.shipmentCreateDate = this.frtBillOfLadingDetails.creationDate;
        this.requiredDeliveryDate = this.frtBillOfLadingDetails.shipmentsInfoEntity?.requiredDeliveryDate;
        this.requiredPickupDate = this.frtBillOfLadingDetails.shipmentsInfoEntity?.moveDate;
        this.shipmentDeliveryDataService.getShipmentDeliveryDataByFrtBolDetailsId(this.frtBillOfLadingDetails.frtBolDetailsID)
          .pipe(takeWhile(() => this.observer$.value))
          .subscribe(deliverydata => {
            if (deliverydata !== null && Object.keys(deliverydata).length !== 0) {
              this.shipmentDeliveryData = deliverydata;
              this.shipmentDeliveryId = this.shipmentDeliveryData.frtShipmentDeliveryId;
              this.shipmentDeliveryForm.controls['actualPickupDate'].setValue(new Date(this.shipmentDeliveryData.actualPickupDate));
              this.shipmentDeliveryForm.controls['actualDeliveryDate'].setValue(new Date(this.shipmentDeliveryData.actualDeliveryDate));
              this.shipmentDeliveryForm.controls['additionalComments'].setValue(this.shipmentDeliveryData.additionalComments);
              this.shipmentDeliveryForm.controls['frtDeliveryExceptionCode'].setValue(this.shipmentDeliveryData.frtDeliveryExcptionsId);
              this.shipmentDeliveryForm.controls['frtPickupExceptionCode'].setValue(this.shipmentDeliveryData.frtPickupExcptionsId);
              this.loadDateandTime(this.shipmentDeliveryData?.actualPickupDate, 1);//1:pickup date
              this.loadDateandTime(this.shipmentDeliveryData?.actualDeliveryDate, 2);//2:delivery date
            } else {
              this.shipmentDeliveryId = null;
            }
            this.loader.hide();
          }, error => {
            this.shipmentDeliveryId = null;
            this.loader.hide();
            this.alertService.error('Error retrieving shipment delivery data');
          });
      }
      this.loader.hide();
    }, error => {
      this.shipmentDeliveryId = null;
      this.loader.hide();
      this.alertService.error('Error retrieving FRT Bill of Lading  details');
    });
  }

  shipmentDeliveryDateValidation(event: any) {
    console.log(event);
    if (this.pickupDateTime === undefined) {
      this.pickupDateTime = this.shipmentDeliveryForm.controls['actualPickupDate'].value;
    }
    if (this.deliveryDateTime === undefined) {
      this.deliveryDateTime = this.shipmentDeliveryForm.controls['actualDeliveryDate'].value;
    }

    if (new Date(this.pickupDateTime) > new Date(this.deliveryDateTime)) {
      this.dateTimeValidation = true;
      this.dateCompareMessage = 'Actual Pickup Date must be before Actual Delivery Date';
    } else {
      this.dateTimeValidation = false;
      this.dateCompareMessage = '';
    }
  }

  ngOnDestroy(): void {
    this.observer$.next(false);
  }

  saveShipmentDeliveryData() {
    this.loader.show();
    const shipmentDelDate = this.shipmentDeliveryForm.value;
    // shipmentDelDate.actualPickupDate = this.shipmentDeliveryForm.value.actualPickupDate;
    shipmentDelDate.actualDeliveryDate = this.combineDateandTime('deliveryDateSelection', 'deliveryTimeSelection');
    shipmentDelDate.actualPickupDate = this.combineDateandTime('pickupDateSelection', 'pickupTimeSelection');
    shipmentDelDate.frtShipmentDeliveryId = this.shipmentDeliveryId;
    shipmentDelDate.frtBolDetailsId = this.shipmentBolDtlsId;
    shipmentDelDate.organizationId = this.organizationId;
    shipmentDelDate.sentToSyncada = 0;
    shipmentDelDate.updateProgram = '';
    shipmentDelDate.updateId = 0;
    shipmentDelDate.updateDate = new Date();
    shipmentDelDate.frtDeliveryExcptionsId = this.shipmentDeliveryForm.value.frtDeliveryExceptionCode;
    shipmentDelDate.frtPickupExcptionsId = this.shipmentDeliveryForm.value.frtPickupExceptionCode;
    delete shipmentDelDate.filePicker;
    this.shipmentDeliveryDataService.saveShipmentDeliveryDataEntity(shipmentDelDate)
      .subscribe
      (data => {
          if (!(data == null)) {
            this.shipmentDeliveryData = data;
            this.shipmentDeliveryId = this.shipmentDeliveryData.frtShipmentDeliveryId;
            this.loader.hide();
            this.alertService.success('Shipment Delivery data has been added/Updated Successfully.');
          } else {
            this.shipmentDeliveryId = null;
            this.loader.hide();
          }
        },
        err => {
          this.shipmentDeliveryId = null;
          this.loader.hide();
          this.alertService.error('Error occurred while saving/Updating Shipment Delivery data.');
        });
  }

  getFrtDeliveryExceptionCodes(){
    this.frtDeliveryExceptionCodesService.getExceptionCodes().subscribe(
      (data: any) => {
        if(data !== null){
          this.exceptionCodes = data;
        }else{
          console.log('no default exception codes');
        }
      },
      (error: any) => {
        console.log('ERROR: no exception codes');
      }
    );
  }

  setfrtDeliveryExceptionCode(){
    if(this.frtBillOfLadingDetails.frtDeliveryExcptionsId !== null)
      this.shipmentDeliveryForm.controls['frtDeliveryExceptionCode'].setValue(this.frtBillOfLadingDetails.frtDeliveryExcptionsId);
  }

  generateHours(){
    this.listHrs = AppConstants.generateHours();
  }

  initCurrentTime(){
    const initTime = AppConstants.initCurrentTime();
    this.shipmentDeliveryForm.get('pickupTimeSelection')?.setValue(initTime);
    this.shipmentDeliveryForm.get('deliveryTimeSelection')?.setValue(initTime);
  }

  loadDateandTime(data: any, identifier: Number){
    const dateTime = moment(data)
    var hr = dateTime.hour();
    var min = dateTime.minute();
    var hrMin = ((hr<10)? ('0'+hr.toString()) : hr.toString()) + (( min < 30) ? ':00' : ':30');

    if(identifier === 1){//pickup date
      this.shipmentDeliveryForm.get('pickupDateSelection')?.setValue(dateTime.format('MM/DD/YYYY').toString());
      this.shipmentDeliveryForm.get('pickupTimeSelection')?.setValue(hrMin);
    } else {//delivery date
      this.shipmentDeliveryForm.get('deliveryDateSelection')?.setValue(dateTime.format('MM/DD/YYYY').toString());
      this.shipmentDeliveryForm.get('deliveryTimeSelection')?.setValue(hrMin);
    }
  }

  combineDateandTime(dateselection: any, timeSelection: any){
    var comb = this.shipmentDeliveryForm.controls[dateselection].value + ' ' + this.shipmentDeliveryForm.controls[timeSelection].value;
    return new Date(Date.parse(comb));
  }

  shipmentPickupDate(event: any){
    this.shipmentDeliveryForm.controls['pickupDateSelection'].setValue(event?.detail['value']);
    this.comparePickupAndDelivery();
  }

  shipmentDeliveryDate(event: any){
    this.shipmentDeliveryForm.controls['deliveryDateSelection'].setValue(event?.detail['value']);
    this.comparePickupAndDelivery();
  }

  shipmentPickupTime(event: any){
    this.comparePickupAndDelivery();
  }

  shipmentDeliveryTime($event: any) {
    this.comparePickupAndDelivery();
  }

  comparePickupAndDelivery(){
    const deliveryTime = this.combineDateandTime('deliveryDateSelection', 'deliveryTimeSelection');
    const pickupTime = this.combineDateandTime('pickupDateSelection', 'pickupTimeSelection');

    console.log(deliveryTime + " sdasdasd " + pickupTime);

    if (new Date(pickupTime) > new Date(deliveryTime)) {
      this.dateTimeValidation = true;
      this.dateCompareMessage = 'Actual Pickup Date cannot be greater than Actual Delivery date';
    } else {
      this.dateTimeValidation = false;
      this.dateCompareMessage = '';
    }
  }
}
